import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { withProcedureWraper } from '..'
import { Routes } from '../../../AppRoutes'
import { Box } from '../../../components/box'
import { Table } from '../../../modules/table'
import { LeaveRequestService } from '../../../services/leave-request/leaveRequest.service'
import { useSelector } from '../../../store/store'
import { getDDMMYYYFormat } from '../../../helper/dateTimeHelper'
import { Icon } from '../../../modules/icon'
import ApprovalStatus from '../../../components/status/approvalStatus'

export const LeaveRequestApprovalHistoryPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const user = useSelector(state => state.user);
  const currentUserName = user?.current?.username;

  const getLeaveRequests = () => {
    return LeaveRequestService.getMyLeaveRequestsApprovalHistory(currentUserName).then(res => {
      return { data: res.reverse(), count: res.length }
    }, error => {
      return { data: [], count: 0 }
    });
  }

  return (
    <div className="LeaveRequestPage">

      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureLeaveRequest.path)}>
              <Icon.ArrowLeft />
            </div>
            {'Đơn xin nghỉ phép'}
          </div>
        </div>
        <Box title="Đang chờ duyệt">
          <Table
            onRowClick={(item) => history.push(Routes.procedureLeaveRequestDetail.path.replace(':id', item.id))}
            structure={[
              {
                name: 'Ngày tạo',
                render: (item) => getDDMMYYYFormat(item.createdDateTime)
              },
              {
                name: 'Nhân viên',
                render: (item) => {
                  return `${item.createdBy.user.displayName}`
                }
              },
              {
                name: 'Thời gian nghỉ',
                render: (item) => <span>{
                  `Từ ${getDDMMYYYFormat(item.fields.eLeaveStartDate)} Đến ${getDDMMYYYFormat(item.fields.eLeaveEndDate)}`
                }
                </span>
              },
              {
                name: 'Tổng số ngày nghỉ',
                render: (item) => item.fields.eDuration
              },
              {
                name: 'Loại',
                render: (item) => item.fields.eLeaveType
              },
              {
                name: 'Lý do',
                render: (item) => item.fields.eLeaveReason
              },
              {
                name: 'Quyết định',
                render: (item) => <ApprovalStatus status={item.fields.eRquestStatus} />
              }
            ]}
            onFetchData={getLeaveRequests}
          />
        </Box>
      </div>
    </div>
  )
})